import React from 'react';
import { Group, Paper } from '@mantine/core';

interface Props {
  children?: React.ReactNode;
}

export const ButtonBar = ({ children }: Props): JSX.Element => {
  return (
    <Paper withBorder radius="md" className="p-4">
      <Group justify="flex-end">{children}</Group>
    </Paper>
  );
};
